import {useContext} from "react";
import {CartContext} from "./App";
export const CartMenu = (props) =>{
    const {cartItems} = useContext(CartContext);
    const {setCartItems} = useContext(CartContext);

    const removeItem = (itemName) => {
        const newCart = cartItems.filter((item) => {
            return item.name !== itemName;
        })
        setCartItems(newCart);
    }
    const displayItems = () =>{
        return <> 
        {cartItems.map((item) => {
            return <div className = "item">
                        <img src = {item.pic} alt = ""></img>
                        <p className = "itemName">{item.name}</p>
                        <p className = "itemCost">{"$" + Number(item.cost*(1-item.discount)).toFixed(2) + " x " + item.count}<span>{"$" + Number(item.count*item.cost*(1-item.discount)).toFixed(2)}</span></p>
                        <button className = "removeItem" onClick = {() => removeItem(item.name)}>
                            <svg width="14" height="16" xmlns="http://wsww.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><path d="M0 2.625V1.75C0 1.334.334 1 .75 1h3.5l.294-.584A.741.741 0 0 1 5.213 0h3.571a.75.75 0 0 1 .672.416L9.75 1h3.5c.416 0 .75.334.75.75v.875a.376.376 0 0 1-.375.375H.375A.376.376 0 0 1 0 2.625Zm13 1.75V14.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 14.5V4.375C1 4.169 1.169 4 1.375 4h11.25c.206 0 .375.169.375.375ZM4.5 6.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Zm3 0c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Zm3 0c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Z" id="a"/></defs><use fill="#C3CAD9" fill-rule="nonzero" xlinkHref="#a"/></svg>
                        </button>
                    </div>})}
                    <button className = "checkOut" onClick = {() => setCartItems([])}>Checkout
                    </button>
            </>
    }

    return <>
        <button className = "clickOut" onClick = {props.togglePop}></button>   
        <div className = "cartMenu">
                <p className = "cartTitle">Cart</p>
                <hr></hr>
                <div className = "cartItems">
                    {cartItems.length === 0 ? <p>Your cart is empty</p>: 
                    (displayItems())}
                </div>

            </div>
        </>
}